export default "__VITE_ASSET___HZaNYgu__"